import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const SubCategoryEdit = () => {
  const [form, setForm] = useState({
    subcategory_name: "",
    category_id: "",
    status: "",
    image: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  // ==============================
  // GET SUBCATEGORY BY ID — FIXED
  // ==============================
  useEffect(() => {
    const fetchSubcategory = async () => {
      try {

        const formData = new FormData();
        formData.append("subcategory_id", id);

        const res = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_id_main_subcategory",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );


        if (res.data?.data) {
          setForm({
            subcategory_name: res.data.data.subcategory_name,
            category_id: res.data.data.category_id,
            status: "Active", // API does not return status, default Active
            image: res.data.data.image,
          });
        }
      } catch (error) {
        console.error("GET ERROR:", error);
        toast.error("Failed to load subcategory data!");
      }
    };

    fetchSubcategory();
  }, [id]);

  // ==============================
  // GET CATEGORY LIST FOR DROPDOWN
  // ==============================
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );

        if (Array.isArray(response.data.row)) {
          setCategories(response.data.row);
        }
      } catch (error) {
        console.error("Category Load Error:", error);
      }
    };

    fetchCategories();
  }, []);

  // ==============================
  // INPUT HANDLER
  // ==============================
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ==============================
  // SUBMIT UPDATE — FIXED
  // ==============================
  const submitForm = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("subcategory_id", id);
    fd.append("subcategory_name", form.subcategory_name);
    fd.append("category_id", form.category_id);
    fd.append("status", form.status);

    if (imageFile) {
      fd.append("image", imageFile);
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/Update_main_subcategory",
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status === true) {
        toast.success("Subcategory updated successfully!");
        navigate("/sub-category-list");
      } else {
        toast.error(response.data.message || "Update failed");
      }
    } catch (error) {
      console.error("UPDATE ERROR:", error);
      toast.error("Something went wrong while updating!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* HEADER */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Sub Category Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="#">Sub Category</a>
                </li>
                <li className="breadcrumb-item active">Edit</li>
              </ol>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="row">
          <div className="col-xl-9 col-lg-8">

            {/* IMAGE */}
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Thumbnail Photo</h4>
              </div>
              <div className="card-body">
                <div className="dropzone bg-light-subtle py-5">
                  <input
                    type="file"
                    onChange={(e) => setImageFile(e.target.files[0])}
                  />

                  {/* Existing Image */}
                  {form.image && (
                    <img
                      src={`https://cyberathon.com/multivendor/${form.image}`}
                      alt="Preview"
                      style={{ width: "120px", marginTop: "10px" }}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* GENERAL INFO */}
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">General Information</h4>
              </div>

              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row">

                    {/* Subcategory Name */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Subcategory Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="subcategory_name"
                        value={form.subcategory_name}
                        onChange={changeHandler}
                        required
                      />
                    </div>

                    {/* CATEGORY DROPDOWN */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Category</label>
                      <select
                        className="form-control"
                        name="category_id"
                        value={form.category_id}
                        onChange={changeHandler}
                        required
                      >
                        <option value="">-- Select Category --</option>

                        {categories.map((cat) => (
                          <option key={cat.category_id} value={cat.category_id}>
                            {cat.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* STATUS */}
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={form.status}
                        onChange={changeHandler}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>

                  </div>

                  {/* BUTTONS */}
                  <div className="p-3 bg-light mb-3 rounded">
                    <div className="row justify-content-end g-2">

                      <div className="col-lg-2">
                        <button type="submit" className="btn btn-outline-secondary w-100">
                          Save Change
                        </button>
                      </div>

                      <div className="col-lg-2">
                        <Link to="/sub-category-list" className="btn btn-primary w-100">
                          Cancel
                        </Link>
                      </div>

                    </div>
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>

      </div>

      <footer className="footer text-center">
        © Venton. Crafted with ❤️ by Techzaa
      </footer>
    </div>
  );
};

export default SubCategoryEdit;
